var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVidt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.866 1c1.03 0 1.865.835 1.865 1.866v23.04l5.798-3.339h-.274V8.09a1.866 1.866 0 0 1 2.78-1.627l13.806 7.761a1.866 1.866 0 0 1 .017 3.243L5.797 30.751A1.866 1.866 0 0 1 3 29.135V2.866C3 1.836 3.835 1 4.866 1zm11.12 19.576 8.167-4.706-8.168-4.591v9.296z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVidt);
export default __webpack_public_path__ + "static/media/VIDT.d60494c28fa1154780631a90f943dfd1.svg";
export { ForwardRef as ReactComponent };